export const Name = 'funnel-employment-type-nudge';
